import type { AxiosInstance } from 'axios'

import { BLOG_STATUS_TRANSITION_TYPE } from '../../constants/enums/blog.enum.constant'

export const updateBlogStatus = (api: AxiosInstance) => (
  blogId: string,
  action: keyof typeof BLOG_STATUS_TRANSITION_TYPE
) => api.post(`/v1.0/admin/blogs/${blogId}/status/${action}`)
